module.exports = __webpack_public_path__ + "img/impeller.d7e4a934.png";